import styled, {css} from "styled-components"
import {Label} from "@irati/ui/src/Typography"

export const StyledSection = styled.section`
  ${({theme}) => css`
    margin: ${theme.spacing.four} -${theme.spacing.four} 0 -${theme.spacing.four};
    padding: ${theme.spacing.three};
    background: ${theme.colors.utility.highlight};
  `}
`

export const AvailableBalance = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${Label} {
    ${({theme}) => css`
      color: ${theme.colors.utility.contrast};
    `}
  }
`
